// Cópia para a área de transferência. O médico cola campo a campo no prontuário
// oficial (e-SUS PEC / PEP) — é o gesto central do produto. Devolve boolean para
// o chamador dar o feedback visual ("Copiado ✓") só quando de fato copiou.

export async function copiar(texto: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(texto);
    return true;
  } catch {
    return false;
  }
}
